import React, { Component } from 'react';
import { Form, Button } from 'semantic-ui-react';
import AssetGallery from '../../components/common/AssetGalleryV2/AssetGallery';

import './CardTab.css';

class CardTab extends Component {
  state = {
    showConfirm: false,
    cardId: '',
    cardImageUrl: null
  };

  openDialog = (e, { data }) => {
    this.setState({ showConfirm: true, cardId: data.cardId });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false, cardId: '' });
  };

  handleConfirm = () => {
    this.props.removeCard(this.state.cardId);
    this.setState({ showConfirm: false, cardId: '' });
  };

  onSelectAsset = (asset, name, cardNumber) => {
    this.props.onSelectAssetCard(asset, name, cardNumber);
  };

  componentDidMount() {
    this.setState({ cardImageUrl: this.props.card.cardImageUrl });
  }

  render() {
    return (
      <div>
        {this.props.card ? (
          <div className="card-container-space">
            <Form.Input
              className="input-name"
              placeholder="Name"
              type="text"
              name="cardName"
              id={this.props.cardNumber}
              defaultValue={this.props.card.cardName}
              onChange={this.props.handleCardChange}
            />
            <div
              className={
                this.props.card.id
                  ? 'asset-gallery-container card-gallery-modal'
                  : 'asset-gallery-container'
              }>
              <AssetGallery
                getFbToken={this.props.getFbToken}
                onAssetSelected={(asset) =>
                  this.onSelectAsset(
                    asset,
                    'cardImageUrl',
                    this.props.cardNumber
                  )
                }
                assetType="image"
                previewFileUrl={this.state.cardImageUrl}
              />
            </div>
            <Form.Input
              className="input-name"
              placeholder="Target Url"
              type="text"
              id={this.props.cardNumber}
              name="cardTargetUrl"
              defaultValue={this.props.card.cardTargetUrl}
              onChange={this.props.handleCardChange}
            />
            {!this.state.showConfirm &&
            this.props.cardNumber !== 1 &&
            this.props.card.id ? (
              <Button
                data={{ cardId: this.props.card.id }}
                onClick={this.openDialog}
                className="delete-button"
                size="big"
                color="grey">
                <i className="info trash icon trash-format" />
              </Button>
            ) : null}
            <div className="delete-card">
              {this.state.showConfirm ? (
                <div className="div-confirm">
                  <p className="text-confirm">Are you sure?</p>
                  <Button
                    onClick={this.handleConfirm}
                    size="mini"
                    color="grey"
                    className="confirm-buttons">
                    Yes
                  </Button>
                  <Button
                    onClick={this.handleCancel}
                    size="mini"
                    color="red"
                    className="confirm-buttons">
                    No
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default CardTab;



// WEBPACK FOOTER //
// ./src/screens/Canvas/CardTab.js